export class TipoLayout {
    codigo_tipo_layout: number;
    sigla: string;
    descricao: string;
    apenas_leitura: boolean;
}
